import { post, get } from '@/api/core'

export namespace upload {
  export function getUploadVideoSignUrl(body: {
    md5: string
    module: Models.FileUploadModule
    filename: string
    contentLength: number
  }) {
    return post<{
      fileId: number
      fileName: string
      /** 是否已上传过 */
      hasUpload: boolean
      /** 预上传签名链接 */
      signUrl: string
    }>('/upload/sign_url', {}, body)
  }

  export function uploadVideoStatus(params: { fileId: number }) {
    return get<{}>('/upload/update_status', { ...params })
  }

  export function uploadVideoDownloadUrl(params: { fileId: number }) {
    return get<{ cdnDownloadUrl: string; downloadUrl: string; fileId: number; fileName: string }>(
      '/download',
      { ...params }
    )
  }

  export function getSliceUploadVideoSignUrl(body: {
    md5: string
    module: Models.FileUploadModule
    filename: string
    contentLength: number
    partNumber: number
  }) {
    return post<{ fileId: number, fileName: string, hasUpload: boolean, signUrl: string }>('/upload/multipart/sign_url', {}, body)
  }

  /** 合并分片 */
  export function sliceVideoUploadedCheck(body: { fileId: number }) {
    return post('/upload/multipart/complete', {}, body)
  }
}
